import { UserRound } from 'lucide-react'
import {
	MdAdminPanelSettings,
	MdArticle,
	MdAttachMoney,
	MdDescription,
	MdOutlineWidgets,
	MdPeopleOutline,
	MdPodcasts,
	MdRoute,
	MdSettings,
	MdTrendingUp,
	MdBalance
} from 'react-icons/md'

export const cardsItemMenu = {
	main: [
		{
			id: 1,
			dataTest: 'client',
			route: '/clientes',
			textCard: 'Clientes',
			icon: UserRound,
		},
		{
			id: 2,
			dataTest: 'routes',
			route: '/',
			textCard: 'Rotas',
			icon: MdRoute,
		},
		{
			id: 3,
			dataTest: 'order',
			route: '/pedidos',
			textCard: 'Pedidos',
			icon: MdDescription,
		},
		{
			id: 4,
			dataTest: 'transmission',
			route: '/transmitir',
			textCard: 'Transmitir',
			icon: MdPodcasts,
		},
		{
			id: 5,
			dataTest: 'reports',
			route: '/relatorios',
			textCard: 'Relatórios',
			icon: MdArticle,
		},
		{
			id: 6,
			dataTest: 'settings',
			route: '/',
			textCard: 'Configurações',
			icon: MdSettings,
		},
	],
	report: [
		{
			id: 1,
			route: '/relatorios/meta',
			textCard: 'Meta',
			icon: MdTrendingUp,
			niveisAcesso: [1, 2, 3],
		},
		{
			id: 2,
			route: '/relatorios/comissao',
			textCard: 'Comissão',
			icon: MdAttachMoney,
			niveisAcesso: [1],
		},
		{
			id: 3,
			route: '/relatorios/vendas_cliente',
			textCard: 'Vendas Cliente',
			icon: MdPeopleOutline,
			niveisAcesso: [1, 2, 3],
		},
		{
			id: 4,
			route: '/relatorios/vendas_produto',
			textCard: 'Vendas Produto',
			icon: MdOutlineWidgets,
			niveisAcesso: [1, 2, 3],
		},
		{
			id: 6,
			route: '/relatorios/gestao',
			textCard: 'Relatório Gerencial',
			icon: MdAdminPanelSettings,
			niveisAcesso: [3],
		},
		{
			id: 7,
			route: '/relatorios/comparativo',
			textCard: 'Relatório Comparativo',
			icon: MdBalance,
			niveisAcesso: [3],
		}
	],
}
